<template>
<div>
    <b-card :header="$t('[[[Regulaminy]]]')">
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>{{ $t('[[[Nazwa regulaminu]]]') }}</th>
                    <th>{{ $t('[[[Rozpoczęcie obowiązywania]]]') }}</th>
                    <th>{{ $t('[[[Status akceptacji]]]') }}</th>
                    <th>{{ $t('[[[Akcje]]]') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in marketingConsents" :key="item.id">
                    <td>{{ item.consentTypeName }}</td>
                    <td>{{ item.startDateUtc | date }}</td>
                    <td>
                        <template v-if="item.requiresApproval === false">
                            <span class="accepted">{{ $t('[[[Ten regulamin nie wymaga akceptacji]]]') }}</span>
                        </template>
                        <template v-else-if="item.accepted">
                            <span class="accepted">{{ $t('[[[Zaakceptowany]]]') }}</span>
                            <span> - {{ item.acceptanceDateUtc | datetime }}</span>
                        </template>
                        <template v-else>
                            <span class="unaccepted">{{ $t('[[[Niezaakceptowany]]]') }}</span>
                        </template>
                    </td>
                    <td>
                        <b-button variant="outline-info" :to="{name:'marketing-consents-view', params: { type: item.consentType }}" :title="$t('[[[Zobacz treść]]]')">
                            <i class="fas fa-file-alt"></i>
                        </b-button>
                        <b-button v-if="item.accepted" variant="danger" :id="`btn-cancel-${item.id}`" :title="$t('[[[Odwołaj zgodę]]]')" :disabled="!item.accepted">{{ $t('[[[Odwołaj zgodę]]]') }}</b-button>
                        <confirmation :message="$t('[[[Na pewno chcesz odwołać akceptację tego regulaminu]]]' + '?')" :target="`btn-cancel-${item.id}`" :value="item" @confirm="cancelAcceptance" />
                    </td>
                </tr>
                <template v-if="privacyPolicy !== null">
                    <tr>
                        <td>{{ privacyPolicy.consentTypeName }}</td>
                        <td>{{ privacyPolicy.startDateUtc | date }}</td>
                        <td>
                            <template v-if="privacyPolicy.accepted">
                                <span class="accepted">{{ $t('[[[Zaakceptowany]]]') }}</span>
                                <span> - {{ privacyPolicy.acceptanceDateUtc | datetime }}</span>
                            </template>
                            <template v-else>
                                <span class="unaccepted">{{ $t('[[[Niezaakceptowany]]]') }}</span>
                            </template>
                        </td>
                        <td>
                            <b-button variant="outline-info" @click="privacyPolicyData.show = true" :title="$t('[[[Zobacz treść]]]')">
                                <i class="fas fa-file-alt"></i>
                            </b-button>
                            <b-button v-if="privacyPolicyData.dateAccepted !== null" variant="danger" :id="`pivacy-policy-cancel`" :title="$t('[[[Odwołaj zgodę]]]')" @click="cancelPrivacyPolicyAcceptance">{{ $t('[[[Odwołaj zgodę]]]') }}</b-button>
                            <confirmation :message="$t('[[[Na pewno chcesz odwołać akceptację tego regulaminu]]]' + '?')" :target="`pivacy-policy-cancel`" :value="true" @confirm="cancelPrivacyPolicyAcceptance" />
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </b-card>

    <privacy-policy-modal :show="privacyPolicyData.show" :data="privacyPolicyData.content" :cookies="privacyPolicyData.cookies" :allowClose="privacyPolicyData.dateAccepted != null" @onClose="privacyPolicyData.show = false" @accept="resetPrivacyPolicy"></privacy-policy-modal>
</div>
</template>

<script>
import MarketingConsentsService from '@/services/core/MarketingConsentsService';
import PrivacyPolicyModal from '@/components/PrivacyPolicyModal.vue';

export default {
    components: {
        'privacy-policy-modal': PrivacyPolicyModal
    },
    data()
    {
        return {
            items: [],
            privacyPolicyData: {
                content: null,
                show: false,
                dateAccepted: null,
                cookies: false
            }
        };
    },

    async created()
    {
        await this.loadData();
    },

    computed: {
        marketingConsents()
        {
            return this.items.filter(x => x.consentType !== 5);
        },

        privacyPolicy()
        {
            if (this.items.length === 0) return null;

            var index = this.items.findIndex(x => x.consentType === 5);

            return index !== -1 ? this.items[index] : null;
        }
    },

    methods: {
        async loadData()
        {
            try
            {
                let response = await MarketingConsentsService.getCurrentUserConsentStatuses(true);
                this.items = response.data;

                let privacyPolicyResponse = await MarketingConsentsService.getPrivacyPolicyExtended();
                this.privacyPolicyData.show = false;
                this.privacyPolicyData.cookies = privacyPolicyResponse.data.cookiesAccepted;
                this.privacyPolicyData.dateAccepted = privacyPolicyResponse.data.userAcceptedDate;
                this.privacyPolicyData.content = privacyPolicyResponse.data.data;
            }
            catch (ex)
            {
                this.items = [];
                this.$log.debug(ex);
            }
        },

        async resetPrivacyPolicy()
        {
            let privacyPolicyResponse = await MarketingConsentsService.getPrivacyPolicyExtended();
            this.privacyPolicyData.show = false;
            this.privacyPolicyData.cookies = privacyPolicyResponse.data.cookiesAccepted;
            this.privacyPolicyData.content = privacyPolicyResponse.data.data;
        },

        async cancelAcceptance(item)
        {
            try
            {
                await MarketingConsentsService.removeAcceptance(item.id);
                this.$alert.success(this.$t('[[[Zgoda została anulowana.]]]'));
                await this.loadData();
            }
            catch (ex)
            {
                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                this.$log.debug(ex);
            }
        },

        async cancelPrivacyPolicyAcceptance(item)
        {
            try
            {
                await MarketingConsentsService.removePrivacyPolicyAcceptance();
                this.$alert.success(this.$t('[[[Zgoda została anulowana.]]]'));
                await this.loadData();
            }
            catch (ex)
            {
                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                this.$log.debug(ex);
            }
        }
    }
};
</script>

<style lang="scss">
    .accepted {
        color: limegreen;
        text-transform: uppercase;
        font-weight: bold;
    };

    .unaccepted {
        color: red;
        text-transform: uppercase;
        font-weight: bold;
    };
</style>
